import React from "react";
import moment from "moment";
import { MoneyStr } from "../../../core/Money";
import { getProlongationLabel } from "../../../enums/prolongationOptions";
export const Wall = (props) => {
    const { eventActions, eventData } = props;
    let total = eventActions.length || 0;
    var lastWinningEnrollment = null;
    const actionDescription = (bidData, index, total) => {
        // console.log("-------DESC", index);
        lastWinningEnrollment = null;
        for (let i = index; i < total; i++) {
            if (eventActions[i].action == 'bid') {
                lastWinningEnrollment = eventActions[i].enrollment;
                break;
            }
            // console.log("Checking last winner", eventActions[i]);
        }
        switch (bidData.action) {
            case 'bid':
                if (bidData.price == eventData.lowest_bid) { //&& index == total - 2
                    return `Účastník <b>č.${bidData.enrollment}</b> se přihlašuje k nejnižšímu podání <b>${MoneyStr(bidData.price)}</b>.`;
                }
                else {
                    if (bidData.price == bidData.price_original) { //
                        return `Účastník <b>č.${bidData.enrollment}</b> dorovnává podání na částku <b>${MoneyStr(bidData.price)}</b> (předkupní právo)`;
                    }
                    else {
                        return `Účastník <b>č.${bidData.enrollment}</b> zvyšuje podání na částku <b>${MoneyStr(bidData.price)}</b>`;
                    }
                }
                break;
            case 'start':
                return `Aukce zahájena.`;
                break;
            case 'call1':
                return lastWinningEnrollment ? `Poprvé pro účastníka <b>č.${lastWinningEnrollment}</b>.` : `První výzva - neučiní-li nikdo z účastníků aukce podání, bude aukce ukončena.`;
                break;
            case 'call2':
                return lastWinningEnrollment ? `Podruhé pro účastníka <b>č.${lastWinningEnrollment}</b>.` : `Druhá výzva - neučiní-li nikdo z účastníků aukce podání, bude aukce ukončena.`;
                break;
            case 'call3':
                return lastWinningEnrollment ? `Neučiní-li někdo z přítomných účastníků aukce podání vyšší, než bylo podání naposled učiněné účastníkem <b>č.${lastWinningEnrollment}</b>, udělím mu příklep.` : `Třetí výzva - neučiní-li nikdo z účastníků aukce podání, bude aukce ukončena.`;
                break;
            case 'prolongation':
                let prStr = getProlongationLabel(eventData.prolongation_time);
                return `Aukce je automaticky prodloužena (došlo k příhozu méně než ${prStr} před koncem)`;
                break;
            /*case 'unavailability_prolongation':
            $msg=$helper->dict('action_unavailability_prolongation', $helper->time_full($action['end'], $action['end_micro']));
            break;*/
            case 'end':
                return eventData.winner_enrollment_id ? `Vítězem aukce je účastník <b>č.${eventData.winner_enrollment_id}</b>` : `V aukci nebyly podány žádné nabídky.`;
                break;
            case 'closed':
                return `Aukce je ukončena`;
                break;
        }
    };
    return React.createElement(React.Fragment, null,
        React.createElement("div", { className: "ed-timeline" },
            React.createElement("h2", { className: "h4" }, "Pr\u016Fb\u011Bh aukce"),
            React.createElement("div", { className: "ed-timeline-inner" },
                eventActions && eventActions.map((act, index) => {
                    return React.createElement("div", { key: act.id, className: "ed-tli" },
                        React.createElement("div", { className: "time" },
                            React.createElement("span", { className: "hours" },
                                moment.unix(act.created).format('HH:mm:ss'),
                                ",",
                                act.created_micro.padStart(3, "0")),
                            React.createElement("span", { className: "date" }, moment.unix(act.created).format('D. M. YYYY'))),
                        React.createElement("div", { className: "text", dangerouslySetInnerHTML: { __html: actionDescription(act, index, total) } }));
                }),
                eventActions && eventActions.length == 0 && React.createElement("div", { className: "text-muted" },
                    "Tady se bude po zah\u00E1jen\u00ED aukce zobrazovat seznam p\u0159\u00EDhoz\u016F a ozn\u00E1nen\u00ED licit\u00E1tora.",
                    React.createElement("br", null)))),
        React.createElement("div", { className: "ed-desc" },
            React.createElement("h2", { className: "h4" }, "Informace"),
            React.createElement("div", { className: "cms-article" }, eventData.description ?
                React.createElement("div", { dangerouslySetInnerHTML: { __html: eventData.description } })
                :
                    React.createElement("div", { className: "text-muted" }, "Nebyly vypln\u011Bny dodate\u010Dn\u00E9 informace."))));
};
